function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawFollowMeDrone = function UndrawFollowMeDrone(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1022.76 792.74",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 412.52,
    y1: 846.37,
    x2: 412.52,
    y2: 195.63,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 887.05,
    y1: 327.55,
    x2: 887.05,
    y2: 209.84,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M174.8 115.43c-5.48 6.65-7.59 16-9.95 24.79-19 70.84-65.82 127.82-119.14 168.52C23.13 325.98-4.36 349.1.58 380.01c2.66 16.6 14.33 28.82 23 42.34C41.77 450.66 47.67 489.14 39 523.03c-9.86 38.56-37.42 74.54-28.89 113.53 5.26 24 23.12 41.08 40.29 55.76q40.18 34.33 82.92 64.32c19.1 13.4 39.42 26.44 61.68 28.14 19.6 1.5 38.8-5.95 57.41-13.3 16.26-6.43 32.93-13.12 46.06-26 8.57-8.41 15.4-19.26 24.92-26.14 22.36-16.16 51.08-5.92 76.72 1 60.5 16.24 125.25 10.31 182.82-16.74 88.31-41.5 155.62-128.65 242-175.41 37.14-20.11 77.54-32.59 111.93-58.49a209.09 209.09 0 0 0 49.2-53.24c26-40.11 40.06-91.25 36-141.31s-26.81-98.3-62.54-126.56c-38.25-30.25-86.56-35.9-130.08-54.06-44.94-18.76-84.92-51-129.43-71.13a264.67 264.67 0 0 0-228.29 5.16c-48.44 24.45-97.54 81.62-151.49 85.92-38.43 3.03-115.42-35.47-145.43.95z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M733.31 627.66l-.66.09L735 626c-25.45 4.14-49.62-11.2-70.52-26.3-3.22-2.33-6.46-4.71-9.68-7.16l-44-49.36a69.84 69.84 0 0 1-4.6-14.4c-2.92-14.51-1-30.34-8-43.42-4.23-8-11.32-14.05-16.48-21.48-22.38-32.25-2.63-77.63-14.1-115.17a72.11 72.11 0 0 0-38.56-43.83A61.58 61.58 0 0 0 530 293a58.67 58.67 0 0 0-2.46-17.38l2.14-1.78s-.85.31-2.39.93c-.06-.18-.1-.36-.16-.54-8.09-24.88-35.72-54.07-113-72.76 0 0-16-6.4-42-5.78C317.54 197 268 228.4 242.67 276.85A68 68 0 0 0 235 304.8c-.6 11.08-1.7 26.74-3.61 40.53a53.39 53.39 0 0 0-.45 8c-.32 22 11.74 46.74 13 49.31v1.12c-.24 3.64.57 17.79 25.79 27.16a36.76 36.76 0 0 1 17.39 13.61c-8.53-.1-16.8-.07-21.51.24-3.59.24-12.47 5.66-23.17 13.15a184.05 184.05 0 0 0-25.68 21.75A194.48 194.48 0 0 0 171 552.06a25.57 25.57 0 0 1-2.21 4.85c-3.36 5.28-10.53 15.2-10.08 33.46-.22 7.88 1 17.47 4.8 29.11-19.5 4.38-46.75 14.1-53.11 34.76C100.2 687.26 90 846.37 90 846.37h632.27s-12.7-100.73-36.3-169.9l11.09-13.71c9.5-3.7 15.06-6 15.06-6l-5.37-6 5.37-6.67s-1.51.88-4.35 2.42l1.9-2.36c8.27-4.83 15.99-10.68 23.64-16.49z",
    transform: "translate(-88.62 -53.63)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    fill: "#b96b6b",
    d: "M172.63 436.49h120v155.83h-120z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M172.63 436.49h120v155.83h-120z"
  }), React.createElement("path", {
    d: "M395.93 333.99a51.69 51.69 0 0 1-31.55 18.25c-12.56 2-25.47-.67-38.09.92s-26.2 9.84-26.93 22.54c-.62 10.86 8.38 21.48 4.89 31.78-1.49 4.38-5 7.72-8.51 10.75-17.34 15-37.38 27.26-51.62 45.24s-21.37 44.47-9 63.8c7.17 11.23 20.17 19.08 23.2 32.05 1.7 7.29-.15 14.89-2.07 22.12-6.13 23.05-16.68 49.49-39.88 55 26.06 25.17 66.33 26.77 102.54 25.31 14.77-.6 29.74-1.49 43.75-6.22s27.14-13.81 33.68-27.06c7.69-15.59 5.25-34 5.09-51.33a184.09 184.09 0 0 1 22.2-89.05c6.59-12.13 14.55-23.52 20.45-36 11.68-24.67 14.8-52.41 17.4-79.58 1.23-12.8 2.35-25.9-.74-38.38-3.23-12.76-16.22-32.19-30.92-33.76-17.56-1.8-25 22.68-33.89 33.62z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M395.93 333.99a51.69 51.69 0 0 1-31.55 18.25c-12.56 2-25.47-.67-38.09.92s-26.2 9.84-26.93 22.54c-.62 10.86 8.38 21.48 4.89 31.78-1.49 4.38-5 7.72-8.51 10.75-17.34 15-37.38 27.26-51.62 45.24s-21.37 44.47-9 63.8c7.17 11.23 20.17 19.08 23.2 32.05 1.7 7.29-.15 14.89-2.07 22.12-6.13 23.05-16.68 49.49-39.88 55 26.06 25.17 66.33 26.77 102.54 25.31 14.77-.6 29.74-1.49 43.75-6.22s27.14-13.81 33.68-27.06c7.69-15.59 5.25-34 5.09-51.33a184.09 184.09 0 0 1 22.2-89.05c6.59-12.13 14.55-23.52 20.45-36 11.68-24.67 14.8-52.41 17.4-79.58 1.23-12.8 2.35-25.9-.74-38.38-3.23-12.76-16.22-32.19-30.92-33.76-17.56-1.8-25 22.68-33.89 33.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M628.89 787.74H6.38s10-156.67 20-189.17c6.07-19.72 31.45-29.31 50.49-33.81a162.23 162.23 0 0 1 22-3.69c44.4 28.9 87.34 45.38 128 53.42 167 33 295.82-76.2 332-53.42 11 6.91 20.76 23.93 29.28 45.72 1.86 4.76 3.66 9.74 5.4 14.89 22.99 68.07 35.34 166.06 35.34 166.06z",
    fill: "#e7e7ee"
  }), React.createElement("path", {
    d: "M238.88 376.9s65.83 171.67-51.67 260.84 237.5 64.17 237.5 64.17l62.5-165.83s-166.67 60-93.33-117.5z",
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M488.47 716.49s52.05 38.33.19 71.25",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M433.88 393.57l185 207.5s-177.5 72.5-241.66 65.83c-34.21-3.55 0-94.16-1.72-172-.12-5.53.64-17.86 1.88-21.53 1-2.86 3.69 4.62 4.69 1.84l.31-.84c19.82-54.46 51.5-80.8 51.5-80.8zM232.22 367.73s-75.84 55.84-69.17 200.84 162.5 105 162.5 105-116.67-121.67-95.83-187.5 2.5-118.34 2.5-118.34z",
    fill: "#777b9b"
  }), React.createElement("path", {
    d: "M229.72 392.73s-37.92-1.25-50.42-.42c-3.53.24-12.28 5.58-22.82 13-31.92 22.34-55.56 54.36-68.76 91a25.19 25.19 0 0 1-2.18 4.78c-5.83 9.17-23.33 32.5 9.17 90 14.84 26.25 23.6 45.21 28.73 58.06a146 146 0 0 0 37.51 54.22c29.2 26.4 77.6 59.4 137.1 59.4 99.17 0 140.83 43.33 202.5-31.67s120-147.5 120-147.5-271.67 157.47-420.83-4.23c0 0-60.84-119.14 30-186.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M593.57 621.68c-22.71 28.07-58.59 72.28-95.68 117.39-61.67 75-103.34 31.67-202.51 31.67-32.28 0-61.3-9.72-85.75-22.82-41.62-22.3-74.2-58.3-93.36-101.45-5.32-12-13-27.63-24.22-47.4-7.43-13.14-12.25-24.5-15.18-34.31a162.23 162.23 0 0 1 22-3.69c44.4 28.9 87.34 45.38 128 53.42 120 90.46 292.68 24.7 361.28-7.7 18.52-8.74-.77-2.42 5.42 14.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M228.05 394.37s-37.92-1.25-50.42-.42c-3.53.24-12.28 5.58-22.82 13-31.92 22.34-55.56 54.36-68.76 91a25.19 25.19 0 0 1-2.18 4.78c-5.83 9.17-23.33 32.5 9.17 90 11.17 19.77 18.9 35.4 24.23 47.4 19.16 43.16 51.74 79.15 93.36 101.45 24.45 13.11 53.47 22.79 85.75 22.79 99.17 0 140.83 43.33 202.5-31.67s120-147.5 120-147.5-271.67 157.5-420.84-4.17c.01.04-60.82-119.13 30.01-186.66z",
    fill: "#cbcdda"
  }), React.createElement("path", {
    d: "M414.89 246.96c5.18 3.7 11.57 5.14 17.54 7.35a70.86 70.86 0 0 1 42.56 45.06c11.29 37-8.16 81.65 13.88 113.4 5.07 7.31 12.06 13.28 16.22 21.15 6.82 12.88 5 28.47 7.84 42.76 6.09 30.27 32.36 51.74 57.39 69.83 20.58 14.87 44.37 30 69.43 25.89-11.24 8.54-22.66 17.19-35.77 22.42s-28.37 6.7-41.18.78c-5.11-2.36-9.68-5.81-14.83-8.08-26.24-11.59-56.71 10.11-84.71 3.88-18.13-4-32.06-19.58-38.69-36.93s-7.06-36.41-6.43-55c.3-8.89.76-18.15-2.82-26.3-4.2-9.58-13.35-16.17-18.19-25.43-8.55-16.38-1.82-36.2 4.75-53.47 9.36-24.6 18.29-49.91 19.09-76.22.94-30.89-8.34-61.28-9.59-92-6.29 6.57-3.36 16 3.51 20.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M416.56 245.3c5.18 3.7 11.57 5.14 17.54 7.35a70.86 70.86 0 0 1 42.56 45.06c11.29 37-8.16 81.65 13.88 113.4 5.07 7.31 12.06 13.28 16.22 21.15 6.82 12.88 5 28.47 7.84 42.76 6.09 30.27 32.36 51.74 57.39 69.83 20.58 14.87 44.37 30 69.43 25.89-11.24 8.54-22.66 17.19-35.77 22.42s-28.37 6.7-41.18.78c-5.11-2.36-9.68-5.81-14.83-8.08-26.24-11.59-56.71 10.11-84.71 3.88-18.13-4-32.06-19.58-38.69-36.93s-7.06-36.41-6.43-55c.3-8.89.76-18.15-2.82-26.3-4.2-9.58-13.35-16.17-18.19-25.43-8.55-16.38-1.82-36.2 4.75-53.47 9.36-24.6 18.29-49.91 19.09-76.22.94-30.89-8.34-61.28-9.59-92-6.29 6.56-3.36 15.98 3.51 20.91z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M375.79 486.02c2.35-15.63 7.8-34.56 17.26-57.46l-155-41.67s11.14 29.06 16.08 69.47c22.45 21.49 46.72 2 80.25 2 12.24.01 30.23 30.94 41.41 27.66z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M466.38 355.07c0 69-35 125.3-104 125.3-62-74-146-56.27-146-125.3a125 125 0 1 1 250 0z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 341.39,
    cy: 356.07,
    r: 125,
    fill: "#ffb9b9"
  }), React.createElement("path", {
    d: "M340.93 313.99c-5.49 9.64-13.51 16.27-22.1 18.25-8.79 2-17.84-.67-26.68.92a23.73 23.73 0 0 0-18.86 22.54c-.44 10.86 5.87 21.48 3.43 31.78-1 4.38-3.51 7.72-6 10.75-12.14 15-26.18 27.26-36.15 45.24s-15 44.47-6.33 63.8c5 11.23 14.12 19.08 16.25 32.05 1.19 7.29-.1 14.89-1.45 22.12-4.29 23.05-11.68 49.49-27.93 55 18.25 25.17 46.46 26.77 71.82 25.31 10.34-.6 20.83-1.49 30.64-6.22a46.64 46.64 0 0 0 23.59-27.06c5.39-15.59 3.68-34 3.57-51.33-.2-30.92 5.21-61.88 15.55-89.05 4.61-12.13 10.19-23.52 14.33-36 8.18-24.64 55.95-140.55 57.77-167.72.86-12.8-43.93 62.28-46.1 49.8-2.22-12.8-11.32-32.23-21.61-33.8-12.29-1.8-17.52 22.68-23.74 33.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M339.26 313.16c-5.49 9.64-13.51 16.27-22.1 18.25-8.79 2-17.84-.67-26.68.92a23.73 23.73 0 0 0-18.86 22.54c-.44 10.86 5.87 21.48 3.43 31.78-1 4.38-3.51 7.72-6 10.75-12.14 15-26.18 27.26-36.15 45.24s-15 44.47-6.33 63.8c5 11.23 14.12 19.08 16.25 32.05 1.19 7.29-.1 14.89-1.45 22.12-4.29 23.05-11.68 49.49-27.93 55 18.25 25.17 46.46 26.77 71.82 25.31 10.34-.6 20.83-1.49 30.64-6.22a46.64 46.64 0 0 0 23.59-27.06c5.39-15.59 3.68-34 3.57-51.33-.2-30.92 5.21-61.88 15.55-89.05 4.61-12.13 10.19-23.52 14.33-36 8.19-24.64 61.62-140.72 63.44-167.89.86-12.8-49.6 62.45-51.77 50-2.22-12.79-11.32-32.22-21.61-33.76-12.3-1.87-17.51 22.6-23.74 33.55z",
    fill: "#b96b6b"
  }), React.createElement("path", {
    d: "M397.31 340.22c37.16-30.63 75.1-67.9 75.1-67.9s54.55-80.42-121.89-117.95c0 0-17.93-6.3-47-5.69-61.29 1.28-116.77 32.23-145.21 79.93a62.44 62.44 0 0 0-6 13.35 59.68 59.68 0 0 0-2.62 14.17c-.67 10.91-1.91 26.33-4 39.91-3.79 24.17 14.23 55 14.23 55s-3.86 17 28.8 27.61a40.72 40.72 0 0 1 20.14 14.2 34.51 34.51 0 0 1 4.4 7.87 32 32 0 0 1 2.11 8.57c1.31 12.78 6.52 36.25 27.08 39.26 0 0 8.24-7.8 20.47-18.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M471.44 270.65s-37.83 37.27-74.88 67.9l-134.07 90.08c-12.19 10.47-20.41 18.27-20.41 18.27-20.51-3-25.7-26.48-27-39.26a30.91 30.91 0 0 0-1.2-6c-.26-.87-.57-1.73-.9-2.58a34.54 34.54 0 0 0-4.39-7.87 40.6 40.6 0 0 0-20.08-14.2c-32.56-10.62-28.71-27.62-28.71-27.62s-18-30.83-14.19-55c2.13-13.58 3.36-29 4-39.91a59.83 59.83 0 0 1 2.64-14.09 62.53 62.53 0 0 1 6-13.35c28.36-47.71 83.67-78.66 144.78-79.93 29-.61 46.9 5.69 46.9 5.69 86.33 18.4 117.21 47.14 126.25 71.64 9.37 25.37-4.74 46.23-4.74 46.23z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M111.8 693.15s-30 43.33 6.67 94.58M216.38 412.37s68.75-52.55 108.75-106.72 144.25-94.28 144.25-94.28",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1014 213.78a149 149 0 0 0-21.3 1.32 5.11 5.11 0 1 0-10.23 0 149 149 0 0 0-21.3-1.32c-15.77 0-28.55 1.76-28.55 3.94s12.78 3.94 28.55 3.94a149 149 0 0 0 21.3-1.32 5.36 5.36 0 0 0 .33 1.85 3.53 3.53 0 0 0-.34 5.68 9.54 9.54 0 0 0-5.6 5.3 8.58 8.58 0 0 0-4.9-1.83l-53.06-2.44a20.56 20.56 0 0 0-16.63-8.56h-33.43a20.56 20.56 0 0 0-16.72 8.66l-50.42 2.32a8.58 8.58 0 0 0-4.59 1.59 9.56 9.56 0 0 0-4.91-4.84 3.52 3.52 0 0 0 1.55-2.93 3.48 3.48 0 0 0-2.35-3.31 5.39 5.39 0 0 0 .22-1.5 149 149 0 0 0 21.3 1.32c15.77 0 28.55-1.76 28.55-3.94s-12.78-3.94-28.55-3.94a149 149 0 0 0-21.3 1.32 5.19 5.19 0 0 0-5.11-5.26 5.19 5.19 0 0 0-5.11 5.26 149 149 0 0 0-21.3-1.32c-15.77 0-28.55 1.76-28.55 3.94s12.78 3.94 28.55 3.94a149 149 0 0 0 21.3-1.32 5.36 5.36 0 0 0 .33 1.85 3.54 3.54 0 0 0-.21 5.79 9.67 9.67 0 0 0-6.09 9v6.48a9.55 9.55 0 0 0 9.42 9.68h3.75a9.31 9.31 0 0 0 7.55-3.91 8.61 8.61 0 0 0 5.71 2.41l49.44 1.42a21.19 21.19 0 0 0 6.13 6.42c-4.73 4.94-23.19 26.86-20.22 65.49 0 0 3 5.69 10.65 0 0 0-4.9-43 22.54-60.76a6.83 6.83 0 0 0 6.43 4.7h3.5a18.83 18.83 0 0 0-11.6 17.52 18.33 18.33 0 1 0 36.64 0 18.83 18.83 0 0 0-11.6-17.42h3.5a6.83 6.83 0 0 0 6.43-4.7c27.45 17.7 22.55 60.7 22.55 60.7 7.67 5.69 10.65 0 10.65 0 3.41-44.23-21.3-66.57-21.3-66.57h-.45a21.26 21.26 0 0 0 4.63-5.26l52-1.5a8.63 8.63 0 0 0 6-2.65 9.33 9.33 0 0 0 7.73 4.15h3.75a9.55 9.55 0 0 0 9.42-9.68V237a9.69 9.69 0 0 0-5.58-8.83 3.52 3.52 0 0 0-.6-6.35 5.39 5.39 0 0 0 .22-1.5 149 149 0 0 0 21.3 1.32c15.77 0 28.55-1.76 28.55-3.94s-12.79-3.92-28.57-3.92z",
    transform: "translate(-88.62 -53.63)",
    fill: "url(#prefix__b)"
  }), React.createElement("circle", {
    cx: 796.99,
    cy: 231.84,
    r: 17.76,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 796.99,
    cy: 231.84,
    r: 11.98,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 796.99,
    cy: 231.84,
    r: 11.98,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("circle", {
    cx: 796.99,
    cy: 231.84,
    r: 7.85,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 796.99,
    cy: 231.84,
    r: 7.85,
    opacity: 0.25
  }), React.createElement("path", {
    d: "M769.31 205.37s-24 21.07-20.65 62.78c0 0 2.89 5.37 10.33 0 0 0-6.2-52.87 35.11-62.78zM824.66 205.37s24 21.07 20.65 62.78c0 0-2.89 5.37-10.33 0 0 0 6.2-52.87-35.11-62.78z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 759.2,
    y: 169.47,
    width: 72.7,
    height: 40.27,
    rx: 16.95,
    ry: 16.95,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M771.1 200.61l-56.72-1.59a8.51 8.51 0 0 1-8.27-8.5v-2.15a8.51 8.51 0 0 1 8.13-8.5l56.72-2.54a8.51 8.51 0 0 1 8.89 8.5v6.31a8.51 8.51 0 0 1-8.75 8.47zM822.46 200.61l56.72-1.59a8.51 8.51 0 0 0 8.27-8.5v-2.15a8.51 8.51 0 0 0-8.13-8.5l-56.72-2.54a8.51 8.51 0 0 0-8.89 8.5v6.31a8.51 8.51 0 0 0 8.75 8.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M771.1 200.61l-56.72-1.59a8.51 8.51 0 0 1-8.27-8.5v-2.15a8.51 8.51 0 0 1 8.13-8.5l56.72-2.54a8.51 8.51 0 0 1 8.89 8.5v6.31a8.51 8.51 0 0 1-8.75 8.47zM822.46 200.61l56.72-1.59a8.51 8.51 0 0 0 8.27-8.5v-2.15a8.51 8.51 0 0 0-8.13-8.5l-56.72-2.54a8.51 8.51 0 0 0-8.89 8.5v6.31a8.51 8.51 0 0 0 8.75 8.47z",
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 688.77,
    y: 176.08,
    width: 21.89,
    height: 24.37,
    rx: 9.21,
    ry: 9.21,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 883.32,
    y: 176.08,
    width: 21.89,
    height: 24.37,
    rx: 9.21,
    ry: 9.21,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 693.31,
    y: 170.71,
    width: 13.22,
    height: 6.61,
    rx: 2.78,
    ry: 2.78,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 694.55,
    y: 159.55,
    width: 9.91,
    height: 14.87,
    rx: 4.17,
    ry: 4.17,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 673.9,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 725.12,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 888.28,
    y: 170.71,
    width: 13.22,
    height: 6.61,
    rx: 2.78,
    ry: 2.78,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 889.52,
    y: 159.55,
    width: 9.91,
    height: 14.87,
    rx: 4.17,
    ry: 4.17,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 868.86,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 920.08,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 673.9,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 725.12,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 868.86,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 920.08,
    cy: 166.99,
    rx: 27.67,
    ry: 3.72,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("rect", {
    x: 780.47,
    y: 202.1,
    width: 33.04,
    height: 13.22,
    rx: 5.56,
    ry: 5.56,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 780.47,
    y: 202.1,
    width: 33.04,
    height: 13.22,
    rx: 5.56,
    ry: 5.56,
    fill: "#f5f5f5",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 809.38,
    cy: 487,
    rx: 157,
    ry: 20,
    fill: primaryColor,
    opacity: 0.1
  }));
};
UndrawFollowMeDrone.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawFollowMeDrone;